import React from 'react';
import LocationInMap from '../Components/Map/LocationInMap';
import Contact from '../Components/Contact/Contact';
import Department from '../Components/Department/Department';
import Appointment from '../Components/Appointment/Appointment';
import About from '../Components/About/About';
import Contactbox from '../Components/Contactbox/Contactbox';
import PostWrapper from '../Components/Post/PostWrapper';
import TestimonialSlider from '../Components/Slider/TestimonialSlider';
import Hero10 from '../Components/Hero/Hero10';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

const heroData = {
    bgImg: 'images/hero-bg12.jpg',
    bgShape: 'shape/hero-shape.png',
    sliderImages: [
        {
            img: 'images/hero-bg2.jpg',
        }
    ],
    title: ['Ginecologia', 'Medicina Estetica', 'Benessere Intimo', 'Cura Personalizzata', 'Trattamenti Innovativi'],
    heading: "Il tuo benessere,<br>la mia missione.",
    subHeading: "Esperienza, passione e professionalità al servizio della salute femminile.<br>Dalla prevenzione alla bellezza, offro soluzioni per ogni fase della vita."
};


export const ContactboxData = [
    {
        link: 'tel:+393486927058',
        bg: 'blue',
        icon: 'icons/telefono.svg',
        title: 'Telefono Ginecologia',
        subTitle:
            '<a href="tel:+393486927058">+39 348 692 7058</a>'
    },
    {
        link: 'mailto:info@dottoressarosacoppola.it',
        bg: 'blue',
        icon: 'icons/mail.svg',
        title: 'Email',
        subTitle:
            '<a href="mailto:info@dottoressarosacoppola.it">info@dottoressarosacoppola.it</a>'
    },
    {
        link: 'tel:+393519000834',
        bg: 'blue',
        icon: 'icons/telefono.svg',
        title: 'Telefono Estetica',
        subTitle:
            '<a href="tel:+393519000834">+39 351 900 0834</a>'
    },
];


const aboutData = {
    title:
        'Mi dedico con passione al benessere femminile, proponendo soluzioni non invasive e personalizzate per la salute intima e la valorizzazione della bellezza naturale.',
    subTitle:
        'Credo profondamente nel potenziale unico di ogni donna e accompagno le mie pazienti in un percorso fatto di cura, ascolto e attenzione alle esigenze individuali. Con competenza e sensibilità, offro trattamenti avanzati per risolvere disturbi intimi, migliorare il comfort quotidiano e far ritrovare sicurezza e fiducia nel proprio corpo.<br /><br /> Il mio impegno va oltre la semplice cura medica: desidero che ogni donna si senta ascoltata, supportata e valorizzata in ogni fase della vita, dalla pubertà alla menopausa, aiutandola a raggiungere risultati concreti e duraturi.',

    avater: {
        img: 'images/avatar1.png',
        name: 'Dott.ssa Rosa Coppola',
        designation: 'Ginecologa e Medico Estetico',
    },
    timeTable: [
        {
            day: 'Mercoledì',
            startTime: '09:30',
            endTime: '18:30',
        }
    ],
    timeTable2: [
        {
            day: 'Lunedì',
            startTime: '08:30',
            endTime: '18:00',
        }
    ],
    contact: '+39 348 692 7058',
};

const testimonialData = [
    {
        img: 'images/avatar2.png',
        name: 'Libera',
        designation: '5 Stelle',
        subTitle:
            "La mia visita dalla dottoressa è andata più che bene.Segretaria gentile e brava, studio accogliente e pulito e della dottoressa, bhé che dire,gentile,disponibile,ti mette a proprio agio spiegandoti nei minimi dettagli tutto ciò che c'è da sapere. Cinque stelle sono poche...",
    },
    {
        img: 'images/avatar2.png',
        name: 'Rosa',
        designation: '5 Stelle',
        subTitle:
            "Prima di conoscere la dottoressa ero spaventata e intimorita dalla visita ginecologica. In lei ho scoperto una professionista empatica e disponibile, capace di mettere a proprio agio le pazienti. Inoltre ha sempre individuato con precisione la terapia giusta qualora si presentasse un problema, aiutandomi volta per volta a sentirmi bene con me stessa. Grazie a lei la visita dalla ginecologa non fa più paura!!",
    },
    {
        img: 'images/avatar2.png',
        name: 'Anna Paola',
        designation: '5 Stelle',
        subTitle:
            "La dottoressa con i suoi modi gentili mette subito a proprio agio, è meticolosa nelle spiegazioni. La sua professionalità e preparazione infonde sicurezza motivo per cui Ho scelto lei come ginecologa di riferimento e la consiglierei e chiunque me lo chiedesse.",
    },
    {
        img: 'images/avatar2.png',
        name: 'Roberta Lombardo',
        designation: '5 Stelle',
        subTitle:
            "È la mia ginecologa da 16 anni. È sempre disponibile, chiara nella spiegazione durante la visita e molto empatica.Mette a proprio agio la paziente e in un clima di serenità, soprattutto nel periodo più importante per una donna: la gravidanza.",
    },
    {
        img: 'images/avatar2.png',
        name: 'Maria Rosa',
        designation: '5 Stelle',
        subTitle:
            "Professionalità, dedizione, cortesia e sensibilità. Mi segue ormai da anni, è diventata un solido punto di riferimento in quanto sempre pronta, disponibile e obiettiva.",
    },
];

const postData = [
    {
        img: 'images/news/1/NewsOspemifene.png',
        title: 'Ospemifene nel trattamento dell’Atrofia Vulvo-Vaginale',
        date: '22 Luglio 2025',
        subTitle:
            "L’atrofia vulvo-vaginale (AVV) è una condizione cronica e progressiva legata alla ridotta estrogenizzazione dei tessuti...",
        postLink: '/post/ospemifene',
    }
];

const mapLocationURL1 =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3025.9743427969393!2d14.76852497590078!3d40.67453427139935!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133bc23a36b0d58d%3A0x5bcca49bd6764779!2sCorso%20Giuseppe%20Garibaldi%2C%2047%2C%2084123%20Salerno%20SA!5e0!3m2!1sit!2sit!4v1745506732179!5m2!1sit!2sit';

const mapLocationURL2 =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3028.6384819062555!2d15.05313327589771!3d40.615799271408314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1339600cb350c227%3A0x9961d8b9911ba128!2sVia%20XXIV%20Maggio%2C%209%2C%2084025%20Eboli%20SA!5e0!3m2!1sit!2sit!4v1745506814729!5m2!1sit!2sit';

const Home = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollTo) {
            scroller.scrollTo(location.state.scrollTo, {
                duration: 500,
                smooth: true,
                offset: -80,      // regola in base all’altezza del tuo header sticky
            });
            // opzionale: pulisci lo state per evitare scroll multipli
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);
    return (
        <>
            <Hero10 data={heroData} />
            <About data={aboutData} />
            <Department />
            <Appointment />
            <TestimonialSlider data={testimonialData} />
            <PostWrapper data={postData} />
            <Contact />
            <Contactbox data={ContactboxData} />
            <LocationInMap data1={mapLocationURL1} data2={mapLocationURL2} />
        </>
    );
};

export default Home;




